import { createAction, handleActions } from 'redux-actions';
import { _getExtendedBehaviorInformation, _editExtendedBehaviorInformation } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  current_information: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  edit_information: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  }
};

export const getExtendedBehaviorInformationStart = createAction(ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION);
export const getExtendedBehaviorInformationSuccess = createAction(ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS, response => response);
export const getExtendedBehaviorInformationError = createAction(ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION_ERROR, error => error);

export const getExtendedBehaviorInformation = () => (dispatch) => {
  dispatch(getExtendedBehaviorInformationStart());
  return _getExtendedBehaviorInformation().then((response) => {
    dispatch(getExtendedBehaviorInformationSuccess(response));
  }).catch((error) => {
    dispatch(getExtendedBehaviorInformationError(error));
  });
};

export const editExtendedBehaviorInformationStart = createAction(ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION);
export const editExtendedBehaviorInformationSuccess = createAction(ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS, response => response);
export const editExtendedBehaviorInformationError = createAction(ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION_ERROR, error => error);

export const editExtendedBehaviorInformation = (data) => (dispatch) => {
  dispatch(editExtendedBehaviorInformationStart());
  return _editExtendedBehaviorInformation(data).then((response) => {
    dispatch(editExtendedBehaviorInformationSuccess(response));
  }).catch((error) => {
    dispatch(editExtendedBehaviorInformationError(error));
  });
};

const reducer = handleActions({
  //GET_EXTENDED_BEHAVIOR_INFORMATION
  [ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION]: (state) => ({
    ...state, current_information: {
      ...state.current_information,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS]: (state, action) => ({
    ...state,
    current_information: {
      ...state.current_information,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_EXTENDED_BEHAVIOR_INFORMATION_ERROR]: (state, action) => ({
    ...state,
    current_information: {
      ...state.current_information,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_EXTENDED_BEHAVIOR_INFORMATION
  [ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION]: (state) => ({
    ...state, edit_information: {
      ...state.edit_information,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION_SUCCESS]: (state, action) => ({
    ...state,
    edit_information: {
      ...state.edit_information,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_EXTENDED_BEHAVIOR_INFORMATION_ERROR]: (state, action) => ({
    ...state,
    edit_information: {
      ...state.edit_information,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;